import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { IBusinessSubjectRequest, IBusinessItem, IBusinessConfigRequest, IBusinessConfigResponse, IBusinessSubjectItem, IBusinessDetailRequest, IInvoiceSubjectDetail } from '../../../../types/system/base/business';
import { IHainanInvoiceItem } from '@core/main/types';

const hostUrl = getHostbaseUrl();

/**
 * 查询业务线列表
 */
export async function queryBaseBusinessList() {
  let data = [] as IBusinessItem[];

  try {
    const { code, context, message } = await Http.post<IBusinessItem[]>(
      `${hostUrl}/side/sys/business/list`,
    );

    if (code === EAxiosResponseCode.Succeed) {
      data = context || [] as IBusinessItem[];

      return data;
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 查询行业科目配置列表
 * @param params 查询参数
 */
export async function queryBusinessSubjectList(params: IBusinessSubjectRequest) {
  try {
    const { code, context, message } = await Http.post<IBusinessSubjectItem[]>(
      `${hostUrl}/side/sys/business/List/invoiceSub`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return { data: context || [] };
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 配置行业科目关联
 * @param params 配置参数
 */
export async function configBusinessSubject(params: IBusinessConfigRequest) {
  try {
    const { code, message } = await Http.post<IBusinessConfigResponse>(
      `${hostUrl}/side/sys/business/config`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return { data: true };
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 查询行业科目明细
 * @param params 查询参数
 */
export async function queryBusinessSubjectDetail(params: IBusinessDetailRequest) {
  let data = [] as IInvoiceSubjectDetail[];

  try {
    const { code, context, message } = await Http.post<IInvoiceSubjectDetail[]>(
      `${hostUrl}/side/sys/business/detail`,
      params,
    );

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }

    data = context || [];
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 查询行业科目明细
 * @param params 查询参数
 */
export async function queryBusinessSubjectHnDetail(params: IBusinessDetailRequest) {
  let data = [] as IHainanInvoiceItem[];

  try {
    const { code, context, message } = await Http.post<IHainanInvoiceItem[]>(
      `${hostUrl}/side/sys/business/hnDetail`,
      params,
    );

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }

    data = context || [];
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}
